// Module-level Google ID token store.
// SessionStorage is used so the token survives page refreshes within the same tab,
// but is cleared when the tab is closed.

let googleIdToken: string | null = null;
let easyAuthToken: string | null = null;

export function setGoogleIdToken(token: string): void {
    googleIdToken = token;
    sessionStorage.setItem('google_id_token', token);
}

export function getGoogleIdToken(): string | null {
    if (!googleIdToken) {
        googleIdToken = sessionStorage.getItem('google_id_token');
    }
    return googleIdToken;
}

export function setEasyAuthToken(token: string): void {
    easyAuthToken = token;
    sessionStorage.setItem('easy_auth_token', token);
}

export function getEasyAuthToken(): string | null {
    if (!easyAuthToken) {
        easyAuthToken = sessionStorage.getItem('easy_auth_token');
    }
    return easyAuthToken;
}

function getAuthBaseUrl(): string {
    const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071/api';
    return apiBase.endsWith('/api') ? apiBase.slice(0, -4) : apiBase;
}

export async function exchangeGoogleIdTokenForEasyAuthToken(idToken: string): Promise<string> {
    const endpoint = `${getAuthBaseUrl()}/.auth/login/google`;
    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id_token: idToken,
            access_token: idToken,
        }),
    });

    if (!response.ok) {
        throw new Error(`EasyAuth exchange failed (${response.status})`);
    }

    const payload = (await response.json()) as {
        authenticationToken?: string;
    };

    if (!payload.authenticationToken) {
        throw new Error('EasyAuth exchange did not return authenticationToken');
    }

    return payload.authenticationToken;
}

export function clearGoogleIdToken(): void {
    googleIdToken = null;
    easyAuthToken = null;
    sessionStorage.removeItem('google_id_token');
    sessionStorage.removeItem('easy_auth_token');
    sessionStorage.removeItem('google_user_name');
}

/** Decodes a JWT payload without verifying the signature (client-side only). */
export function decodeJwtPayload(token: string): Record<string, unknown> {
    try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(atob(base64));
    } catch {
        return {};
    }
}
